import { TextFormat } from "../TextFormat";
import { FontRestrictionType } from "./dataTypes";
import { FALLBACK_TEXT_COLOR, FALLBACK_TEXT_SIZE, FALLBACK_TEXT_FONT } from "./defaults";

export function applyFormat(ctx: CanvasRenderingContext2D, format: TextFormat, fontRestriction: FontRestrictionType | null) {
    const colorString = typeof format.color === "string" ? format.color : FALLBACK_TEXT_COLOR;
    ctx.fillStyle = colorString;

    const fontString = getFontString(format, fontRestriction);
    ctx.font = fontString;
}

export function getFontFamily(format: TextFormat, fontRestriction: FontRestrictionType | null): string {
    let font = (format && format.font) || FALLBACK_TEXT_FONT;

    if (fontRestriction) {
        if (fontRestriction.fontOverwrites.has(font)) {
            font = fontRestriction.fontOverwrites.get(font)!; // save as we just checked existence
        }

        if (!fontRestriction.allowedFonts.has(font)) {
            font = fontRestriction.fallbackFont;
        }
    }

    return font;
}

function getFontString(format: TextFormat, fontRestriction: FontRestrictionType | null): string {
    const size = (format && format.size) || FALLBACK_TEXT_SIZE;
    const fontFamily = getFontFamily(format, fontRestriction);

    return (format && format.italic ? "italic " : "") + (format && format.bold ? "bold " : "") + `${size}px ${fontFamily}`;
}
